const i = {
  "main-navigation-item": "main-navigation-item",
  "main-navigation-item--active": "main-navigation-item--active",
  "main-navigation-item--open": "main-navigation-item--open",
  "main-navigation-item__submenu": "main-navigation-item__submenu",
  "main-navigation-item--separator": "main-navigation-item--separator",
  "main-navigation-item__button": "main-navigation-item__button",
  "main-navigation-item__link": "main-navigation-item__link"
};
export {
  i as default
};
